module.exports = __webpack_public_path__ + "static/media/hami.51149889.svg";